/**
* Experience Module
**/

VP = window.VP || {};

(function( $ ) {
  VP.experienceModule = {
    window: $(window),

    init: function () {
      var _this = this;
      if ( VP.helpers.isMobile() ) {
        // console.log("[experienceModule] delay exp init for mobile");
        _this.eventHandlers();
      }
      else {
        _this.initExperienceModules();
      }
    },
    checkScrollPosition: function() {
      var _this = this;
      var $sliders = $(".vp-experience-module:not('.loaded')");
      if ( !$sliders.length ) {
       // console.log("[experienceModule] checkScrollPosition all loaded")
        return;
      }
      buffer = $(window).height();  // buffer is one full page height;
      windowTop = $( window ).scrollTop();
      windowBottom = windowTop + $(window).height() + buffer;


      if ($sliders.length >= 1) {
        $sliders.each(function() {
          $slider = $(this);
          if ($slider.offset().top < windowBottom) {
            // if any of them reach window, load them all
            $sliders.addClass("loaded");
            _this.initExperienceModules();
          }
        })

      }
    },
    eventHandlers: function() {
      var _this = this;

      VP.documentEvents.onResize( _this.checkScrollPosition.bind( _this ), true );
      VP.documentEvents.onScroll( _this.checkScrollPosition.bind( _this ), true );
      setTimeout(function() {
        _this.checkScrollPosition();
      },500);

    },
    initExpAd:  function ( slick ) {
      var adid = VP.experienceModule.getAdID( slick );
      // console.log("[experienceModule] initExpAd: "+ adid);
      if (typeof gptadloader == "object") {
        if (typeof gptadloader[adid] == "function") {
          gptadloader[adid]();
        }
      }
    },

    // Ads need to be refreshed after slick carousel breakpoint change
    refreshExpAd: function ( slick ) {
      var adid = VP.experienceModule.getAdID( slick );
      // console.log("[experienceModule] refreshExpAds: "+ adid);
      var refresharray = [];
      if ( gptadslots.length > 0 ) {
        $.each(gptadslots, function( i ) {
          var slotid = this.getSlotElementId();
          if (slotid == adid) {
            refresharray.push(gptadslots[i]);
          }
        });
        if ( refresharray.length > 0 ) {
          if ( window.googletag ) {
            googletag.pubads().refresh(refresharray,{changeCorrelator: false});
          }
        }
      }
    },

    getAdID: function ( slick ) {
      // console.log("[experienceModule] getAdID: " + slick);
      var expad = slick.$slider.find(".vp-ads-exp__ad");
      if (expad.length == 1) {
          var expid = expad.attr("id");
          return expid;
      }
      return "";
    },

    initExperienceModules: function() {
      // console.log("[experienceModule] initExperienceModules");
      var _this = this;
      var $slider = $('.vp-experience-module__blade-items');

      $slider.on('init', function( event , slick ){
        VP.experienceModule.initExpAd( slick );
      });

      $slider.slick({
        'mobileFirst': true,
        'arrows' : true,
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'variableWidth': false,
        'infinite': false,
        'nextArrow': '<a href="#" class="slick-next"><i class="vp-icon-next"><span class="screen-reader-text">Next</span></i></a>',
        'prevArrow': '<a href="#" class="slick-prev"><i class="vp-icon-previous"><span class="screen-reader-text">Previous</span></i></a>',
        'responsive': [
          {
            'breakpoint': 699,
            'settings': {
              'variableWidth': false,
              'slidesToScroll': 1,
              'slidesToShow': 1,
            },
          },
          {
            'breakpoint': 999,
            'settings': {
              'variableWidth': false,
              'slidesToShow': 2,
              'slidesToScroll': 2
            },
          }
        ],
      });

      $slider.on('breakpoint', function(event, slick, currentSlide){
        VP.experienceModule.refreshExpAd( slick );
      });

      $slider.on('afterChange', function(event, slick, currentSlide){
        var $slides = slick.$slider.find('.slick-slide');
        if( !$slides.first().hasClass('slick-slide--force-show') ) {
          $slides.addClass('slick-slide--force-show');
        }
      });

      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $s = slick.$slider;
        var $items = $('.vp-item', $s);
        var x = nextSlide + 1.5;
        var isEven = $items.length % 2 !== 0;
        var isDesktop = _this.window.width() >= 999;
        var isClickingNext = nextSlide > currentSlide;

        if( isEven && isDesktop && (( $items.length / 2 ) === x) && isClickingNext ) {
          slick.postSlide(currentSlide);
        }
      });
    },
  };
})(jQuery);
